import { cn } from "@/lib/utils";

/** Inline spinner for buttons and small inline waits. Inherits `currentColor`. */
export function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
	return (
		<svg
			viewBox="0 0 16 16"
			fill="none"
			role="status"
			aria-label="Loading"
			className={cn("size-4 animate-spin", className)}
			{...props}
		>
			<circle cx="8" cy="8" r="6.25" stroke="currentColor" strokeOpacity="0.2" strokeWidth="1.5" />
			<path
				d="M14.25 8A6.25 6.25 0 0 0 8 1.75"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	);
}

/** Brand loader: the 3×3 logomark grid pulsing in sequence. Use for page/section-level waits. */
export function DotLoader({
	className,
	label = "Loading",
}: {
	className?: string;
	label?: string;
}) {
	return (
		<span
			role="status"
			aria-label={label}
			className={cn("inline-grid grid-cols-3 gap-[3px]", className)}
		>
			{Array.from({ length: 9 }, (_, i) => (
				<span
					// biome-ignore lint/suspicious/noArrayIndexKey: static decorative grid
					key={i}
					className="size-[5px] animate-dot-pulse rounded-full bg-current"
					style={{ animationDelay: `${((i % 3) + (2 - Math.floor(i / 3))) * 90}ms` }}
				/>
			))}
		</span>
	);
}
